import { Editor } from "grapesjs";
import { RequiredPluginOptions } from "../../../../../types/types";
import { html } from "../../../../../utils/tw";
import { getApiData } from "../../../../../helpers/AxiosInstance";
import APIS from "../../../../../constant/Endpoint";

export default async (editor: Editor, opts: RequiredPluginOptions) => {
  const { Components } = editor;
  const formResponse = await getApiData(APIS.FORMS, {});
  Components.addType("quote", {
    isComponent: (el) => {
      if (
        el.className &&
        typeof el.className === "string" &&
        el.className.includes("quote")
      ) {
        return {
          type: "quote",
        };
      }
    },
    model: {
      defaults: {
        tagName: "main",
        classes: ["quote"],
        components: html`
          <section class="container w-full md:mx-auto px-4 md:py-16 py-4 ">
            <div class="flex justify-center ">
              <form
                class="w-full max-w-3xl md:p-[13px]  shadow-[0px_0px_11.6px_0px_rgba(0,0,0,0.25)] p-3  "
              >
                <div class="flex items-center mb-8 ">
                  <div class="w-1 bg-[#FA6914] h-12"></div>
                  <h3
                    class="text-xl md:text-4xl font-bold ml-3 font-roboto leading-1 text-[#0083D7]"
                  >
                    Request a Free Quote
                  </h3>
                </div>

                <div class="grid grid-cols-1 md:grid-cols-2 gap-6 w-full">
                  <div>
                    <label
                      class=" text-normal text-sm md:text-lg font-bold  font-roboto  text-[#272727] tracking-wide"
                      >Full Name*</label
                    >
                    <input
                      type="text"
                      placeholder="Enter your name"
                      class="placeholder:text-normal text-bla font-roboto w-full border border-gray-300 shadow-md rounded-lg p-3"
                    />
                  </div>
                  <div>
                    <label
                      class=" text-normal text-sm md:text-lg font-bold  font-roboto text-[#272727] tracking-wide"
                      >Email*</label
                    >
                    <input
                      type="email"
                      placeholder="Enter your email"
                      class="placeholder:text-normal text-bla font-roboto w-full border  border-gray-300 shadow-md rounded-lg p-3"
                    />
                  </div>
                  <div>
                    <label
                      class=" text-normal text-sm md:text-lg font-bold  font-roboto text-[#272727] tracking-wide"
                      >Freight*</label
                    >
                    <input
                      type="text"
                      placeholder="Enter freight details"
                      class="placeholder:text-normal text-bla font-roboto w-full border  border-gray-300 shadow-md rounded-lg p-3"
                    />
                  </div>
                  <div>
                    <label
                      class=" text-normal text-sm md:text-lg font-bold  font-roboto text-[#272727] tracking-wide"
                      >Incoterms*</label
                    >
                    <input
                      type="text"
                      placeholder="Enter incoterms"
                      class="placeholder:text-normal text-bla font-roboto w-full border  border-gray-300 shadow-md rounded-lg p-3"
                    />
                  </div>
                  <div>
                    <label
                      class=" text-normal text-sm md:text-lg font-bold  font-roboto text-[#272727] tracking-wide"
                      >Total Weight*</label
                    >
                    <input
                      type="text"
                      placeholder="Enter total weight"
                      class="placeholder:text-normal text-bla font-roboto w-full border  border-gray-300 shadow-md rounded-lg p-3"
                    />
                  </div>
                  <div>
                    <label
                      class=" text-normal text-sm md:text-lg font-bold  font-roboto text-[#272727] tracking-wide"
                      >Dimensions*</label
                    >
                    <input
                      type="text"
                      placeholder="Enter dimensions"
                      class="placeholder:text-normal text-bla font-roboto w-full border  border-gray-300 shadow-md rounded-lg p-3"
                    />
                  </div>
                </div>

                <div class="flex justify-center md:mt-10 mt-14 ">
                  <button
                    type="submit"
                    class="font-roboto w-full max-w-full bg-[#0083D7] text-white h-12 rounded-lg shadow-md  "
                  >
                    Submit Now
                  </button>
                </div>
              </form>
            </div>
          </section>
        `,
      },
    },
  });
};
